import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Input, OnInit } from '@angular/core';
import { MatChipInputEvent } from '@angular/material/chips';
import { WoundService } from 'src/app/services/wound.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from 'src/app/services/auth.service';
import * as global from "../../../includes/global";
import { lastValueFrom } from 'rxjs';
import { Router } from '@angular/router';

interface Row {
  row_id: String,
  Value: any,
  dropdownTitle: any,
  row_confirmed: Boolean,
  data_type: String
}

interface UserType{
  id: String,
  text: String
}
interface DataSet {
  header_id: String,
  header: String,
  multiselect_enabled: Boolean,
  header_confirmed: Boolean,
  row: Array<Row>,
  user_types: Array<UserType>
}

@Component({
  selector: 'app-data-sets',
  templateUrl: './data-sets.component.html',
  styleUrls: ['./data-sets.component.css']
})
export class DataSetsComponent implements OnInit {
  userTypeDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 10,
    allowSearchFilter: true,
    enableCheckAll: true,
  };
  userTypes = [
    {
      'id': global.USER_TYPE.DOCTOR,
      text: 'Provider'
    },
    {
      'id': global.USER_TYPE.SNF_WC_NURSE,
      text: 'SNF WC Nurse'
    },
    {
      'id': global.USER_TYPE.MEDICAL_ASSISTANT,
      text: 'MEDICAL ASSISTANT'
    }
  ];
  @Input() set:any;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  data_types = [
    "Text",
    "Date",
    "Dropdown"
  ];
  minDate = moment(new Date()).subtract(7, 'day').toDate();
  columns: DataSet[];
  dataSet: any [];
  loaderId = 'app-data-sets';
  currentUser: any;
  disableEditing: boolean=false;
  companyId: string;
  constructor(private _wound: WoundService,
    private toastr: ToastrService,
    private _authService: AuthService,
    private loader: NgxUiLoaderService,
    private router: Router) {
    this.currentUser = this._authService.currentUser;
    if (this.currentUser.admin_type != 'system_admin') {
      this.disableEditing = true;
    }
    const currentUrl = this.router.url;
    this.companyId = currentUrl.split('/')[2];
  }

  async ngOnInit() {
    this.columns = [];
    if(this.set == 2){
      this.loaderId = 'app-data-sets-2'
    }
    this.loader.startLoader(this.loaderId);
    await this.getAllDatasets();
    this.loader.stopLoader(this.loaderId);
  }
  async onUserTypeSelect(col, index) {
    this.dataSet[index].user_types = col.user_types;
    const filter = {
      _id: col.header_id
    };
    const data = {
      $set: {
        user_types: this.dataSet[index].user_types.map(userType => userType.id)
      }
    };
    if (this.columns[index].header_id) {
      await lastValueFrom(this._wound.updateDataSet(filter, data));
    }
  }
  async onSelectAllUserTypes(col, index) {
    this.dataSet[index].user_types = col.user_types;
    const filter = {
      _id: col.header_id
    };
    const data = {
      $set: {
        user_types: this.userTypes.map(userType => userType.id)
      }
    }
    await lastValueFrom(this._wound.updateDataSet(filter, data));
  }
  async onDeSelectAllUserTypes(col, index) {
    this.dataSet[index].user_types = col.user_types;
    const filter = {
      _id: col.header_id
    };
    const data = {
      $set: {
        user_types: []
      }
    };
    if (this.columns[index].header_id) {
      await lastValueFrom(this._wound.updateDataSet(filter, data));
    }
  }
  async onUserTypeDeSelect(col, index) {
    this.dataSet[index].user_types = col.user_types;
    const filter = {
      _id: col.header_id
    };
    const data = {
      $set: {
        user_types: this.dataSet[index].user_types.map(userType => userType.id)
      }
    };
    if (this.columns[index].header_id) {
      await lastValueFrom(this._wound.updateDataSet(filter, data));
    }
  }
  addColumn() {
    var myObject = {} as DataSet;

    myObject.header_id = "";
    myObject.header = "";
    myObject.header_confirmed = false;
    myObject.multiselect_enabled = false;
    myObject.row = [];
    this.columns.push(myObject);
  }
  async deleteColumn(index) {
    const infoToast = this.toastr.info('Deleting Header', 'Please wait', { disableTimeOut: true });
    if (this.columns[index].header_confirmed == true) {
      let response = await this._wound.removeHeaderfromWoundDataSet(this.columns[index].header_id).toPromise();
      if (response['status'] == 200) {
        this.columns.splice(index, 1);
        this.toastr.clear(infoToast.toastId);
        this.toastr.success('Header Deleted Successfully', 'Success');
      } else {
        this.toastr.clear(infoToast.toastId);
        this.toastr.error('Something went wrong deleting header', 'Failed');
      }
    } else {
      this.columns.splice(index, 1);
      this.toastr.clear(infoToast.toastId);
      this.toastr.success('Header Deleted Successfully', 'Success');
    }
  }
  toggleHeaderState(index) {
    this.columns[index].header_confirmed = !this.columns[index].header_confirmed;
  }
  async ConfirmColumnHeader(index) {
    if (!(this.columns[index].header == "")) {
      if (this.columns[index].header_id == "") {
        const infoToast = this.toastr.info('Adding Header', 'Please wait', { disableTimeOut: true });
        let response = await this._wound.addNewHeaderinWoundDataSet(this.columns[index].header,this.columns[index].multiselect_enabled,this.set,this.companyId).toPromise();
        if (response['status'] == 200) {
          this.columns[index].header_confirmed = !this.columns[index].header_confirmed;
          this.columns[index].header_id = response['data']['_id'];
          this.toastr.clear(infoToast.toastId);
          this.toastr.success('Header Added Successfully', 'Success');
        } else {
          this.toastr.clear(infoToast.toastId);
          this.toastr.error('Something went wrong adding header', 'Failed');
        }
      } else {
        const infoToast = this.toastr.info('Updating Header', 'Please wait', { disableTimeOut: true });
        let response = await this._wound.updateHeader(this.columns[index].header,this.columns[index].multiselect_enabled, this.columns[index].header_id).toPromise();
        if (response['status'] == 200) {
          this.columns[index].header_confirmed = !this.columns[index].header_confirmed;
          this.toastr.clear(infoToast.toastId);
          this.toastr.success('Header Updated Successfully', 'Success');
        } else {
          this.toastr.clear(infoToast.toastId);
          this.toastr.error('Something went wrong', 'Failed');
        }
      }
    }
  }
  toggleRowState(col_index, row_index) {
    this.columns[col_index].row[row_index].row_confirmed = !this.columns[col_index].row[row_index].row_confirmed;
  }
  async ConfirmRow(i, x) { 
    if (!(this.columns[i].row[x].Value == "") ) {
      if((this.columns[i].row[x].data_type != 'Dropdown') || 
        (this.columns[i].row[x].dropdownTitle != undefined && this.columns[i].row[x].dropdownTitle != null && this.columns[i].row[x].dropdownTitle?.trim() != "" )){
        if (this.columns[i].row[x].row_id == "") {
          const infoToast = this.toastr.info('Adding Row', 'Please wait', { disableTimeOut: true });
          let item = {
            data_type: this.columns[i].row[x].data_type,
            value: this.columns[i].row[x].Value,
            dropdownTitle: this.columns[i].row[x].dropdownTitle
          };
          let response = await this._wound.addNewRowinWoundDataSet(this.columns[i].header_id, item).toPromise();
          if (response['status'] == 200) {
            this.columns[i].row[x].row_id = response['row_id'];
            this.columns[i].row[x].row_confirmed = !this.columns[i].row[x].row_confirmed;
            this.toastr.clear(infoToast.toastId);
            this.toastr.success('Row Added Successfully', 'Success');
          } else {
            this.toastr.clear(infoToast.toastId);
            this.toastr.error('Something went wrong adding row', 'Failed');
          }
        } else {
          const infoToast = this.toastr.info('Updating Row', 'Please wait', { disableTimeOut: true });
          let response = await this._wound.updateRowinDataset(this.columns[i].header_id, this.columns[i].row[x].row_id, this.columns[i].row[x].data_type, this.columns[i].row[x].Value, this.columns[i].row[x].dropdownTitle).toPromise();
          if (response['status'] == 200) {
            this.columns[i].row[x].row_confirmed = !this.columns[i].row[x].row_confirmed;
            this.toastr.clear(infoToast.toastId);
            this.toastr.success('Row Updated Successfully', 'Success');
          } else {
            this.toastr.clear(infoToast.toastId);
            this.toastr.error('Something went wrong adding row', 'Failed');
          }
        }
      }
      else{
        this.toastr.error("Add Dropdown title...")
      }
    }
    else{
      this.toastr.error("Add Data...")
    }
  }
  addRow(col_index) {
    var rowObject = {} as Row;
    rowObject.Value = "";
    rowObject.row_id = "";
    rowObject.row_confirmed = false;
    rowObject.data_type = "Text";
    this.columns[col_index].row.push(rowObject);
  }
  async deleteRow(col_index, row_index) {
    const infoToast = this.toastr.info('Deleting Row', 'Please wait', { disableTimeOut: true });
    if (this.columns[col_index].row[row_index].row_confirmed == true) {
      let response = await this._wound.removeRowfromWoundDataSet(this.columns[col_index].header_id, this.columns[col_index].row[row_index].row_id).toPromise();
      if (response['status'] == 200) {
        this.columns[col_index].row.splice(row_index, 1);
        this.toastr.clear(infoToast.toastId);
        this.toastr.success('Row Deleted Successfully', 'Success');
      } else {
        this.toastr.clear(infoToast.toastId);
        this.toastr.error('Something went wrong deleting row', 'Failed');
      }
    } else {
      this.columns[col_index].row.splice(row_index, 1);
      this.toastr.clear(infoToast.toastId);
      this.toastr.success('Row Deleted Successfully', 'Success');
    }
  }
  changetoString(col_index, row_index) {
    if (this.columns[col_index].row[row_index].data_type == 'Date') {
      return this.columns[col_index].row[row_index].Value.format('DD/MM/YYYY');
    } 
    return this.columns[col_index].row[row_index].Value;
  }
  add(event: MatChipInputEvent, col_index, row_index): void {
    const value = (event.value || '').trim();
    if (value) {
      this.columns[col_index].row[row_index].Value.push(value);
    }
    // Clear the input value
    event.input.value = '';
  }
  remove(value: string, col_index, row_index): void {
    const index = this.columns[col_index].row[row_index].Value.indexOf(value);

    if (index >= 0) {
      this.columns[col_index].row[row_index].Value.splice(index, 1);
    }
  }
  changeType(col_index, row_index) {
    if (this.columns[col_index].row[row_index].data_type == 'Date') {
      this.columns[col_index].row[row_index].Value = moment(new Date());
    }
    if (this.columns[col_index].row[row_index].data_type == 'Dropdown') {
      this.columns[col_index].row[row_index].Value = [];
    }
  }
  async getAllDatasets() {
    let response = await this._wound.getAllDatasetinCompany(this.set,this.companyId).toPromise();
    if (response['status'] == 200) {
      this.dataSet = response['data'];
      this.dataSet.forEach((element: any, index) => {
        let myObject = {} as DataSet;
        myObject.header_id = element['_id'];
        myObject.header = element['header'];
        myObject.multiselect_enabled = element['multiselect_enabled'];
        myObject.header_confirmed = true;
        myObject.user_types = this.userTypes.filter(userType => element.user_types.includes(userType.id));
        myObject.row = [];
        element.rows.forEach(element => {
          let rowObject = {} as Row;
          if (element['data_type'] == "Date") {
            rowObject.Value = moment(element['value']);
          } else {
            rowObject.Value = element['value'];
            rowObject.dropdownTitle = element['dropdownTitle'];
          }
          rowObject.row_id = element['_id'];
          rowObject.row_confirmed = true;
          rowObject.data_type = element['data_type'];
          myObject.row.push(rowObject);
        });
        this.columns.push(myObject);
      });
    }
  }
}
